import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import DataService from "../../../services/data.service";
import { IColInfo } from '../../../components/DataTable/Interfaces';
import Title from '../../../components/Headers/Title';
import ItemRevisionStatusModel from '../../../models/ItemRevisionStatusModel';
import { ItemRevisionIdProps } from '../../../types/IdProps';
import { useNotifications } from '../../../contexts/notificationContext';

const ItemRevision_tab_History: React.FC<ItemRevisionIdProps> = ({ itemRevisionId }) => {
    const [statusChanges, setStatusChanges] = useState<any[]>();
    const [changeLog, setChangeLog] = useState<any[]>();
    const { handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [itemRevisionId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/ItemRevisionStatuses/ByItemRevision/' + itemRevisionId)
            .then(response => {
                setStatusChanges(response);
            })
            .catch(e => { handleException(e); });

        DataService.get<any[]>('api/v1/ItemChangeLogs/ByItemRevision/' + itemRevisionId)
            .then(response => {
                setChangeLog(response);
            })
            .catch(e => { handleException(e); });
    }

    const historyColInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Assigned on', dataProp: 'assignedOn', dataType: 'datetime', sort: 'desc' },
        { title: 'Assigned By', dataProp: 'assignedByUser', dataType: 'user', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Status type', dataProp: 'itemStatus.itemStatusType.name', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Status', dataProp: 'itemStatus.name', getCellBackgroundColor: getColor, filterInfo: { filterType: 'CheckboxList' } },
    ];

    const changelogColinfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'When', dataProp: 'createdOn', dataType: 'datetime', sort: 'desc' },
        { title: 'Who', dataProp: 'createdByUser', dataType: 'user', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'What', dataProp: 'remark', filterInfo: { filterType: 'Textbox' } },
        { title: 'Project', dataProp: 'project', dataType: 'project', filterInfo: { filterType: 'CheckboxList' } },
    ];

    function getColor(rowData: ItemRevisionStatusModel, colInfo: IColInfo)
    {
        return rowData.itemStatus.color;
    }

    return (
        <>
            <Title size={4} text='Status changes' />
            <DataTable
                name='dtItemRevisionHistory'
                colInfos={historyColInfos}
                tableData={statusChanges}
            />

            <Title size={4} text='Change log' />
            <DataTable
                name='dtItemRevisionChangeLog'
                colInfos={changelogColinfos}
                tableData={changeLog}
            />

        </>
    );
}
export default ItemRevision_tab_History;
